// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3iHD9","header":"PatientBlock_header__HBpDT","label":"PatientBlock_label__3QH7W","option":"PatientBlock_option__1Fo4L"};